
import { Watch, BaseTLTableComponent, BaseTLTableBase, AxiosResponse, TagService, TagFilter, GlobalSearchFilter, GlobalSearchService } from "../../../Infrastructure/CorBase/CoreBase";

interface iGlobalItemSearch {
	id: number;
	name: string;
	description: boolean;
	typeObject: string;
}

export default class GlobalSearchListBase extends BaseTLTableComponent {
		
	globalSearchService: GlobalSearchService = new GlobalSearchService();
	timer = 0;

	created() {
		super.created(false);
	}

	changeParamBase(params: any) {
		if (params.filters.search != undefined && params.search != this.$store.state.globalSearch) {
			this.$store.commit("globalSearch", params.filters.search); 
		}

		if (this.$store.state.globalSearch != '' && params.filters.search == undefined && params.filters.content == "content" && params.filters.tag == "tag" && params.filters.receiver == "receiver" && params.filters.task == "task") {
			var initParams = {
				filters: {content: 'content', tag: 'tag', task: 'task', receiver: 'receiver', search: this.$store.state.globalSearch }, currentPage: params.currentPage, perPage: params.perPage, sortBy: params.sortBy, sortDesc: params.sortDesc
			};
			params = initParams;			
		}
		
	//TODO - mozná najit lepsi cestu
		if (JSON.stringify(params.filters) != "{}" && params.filters != "" && params.filters != null && JSON.stringify(params.filters) != "") {
				//this.timer = setTimeout(() => {
				//this.tableParams = params;
				//this.fetchData();
				//}, 200);
			this.$nextTick(function () {
				this.tableParams = params;
				this.fetchData();
				this.isBusy = false;//POUZE TEST
			});
		}
	}

	//z bajzu
	fetchDataFromServer(): Promise<AxiosResponse<any>> {		
		let filter: GlobalSearchFilter = new GlobalSearchFilter(this.$store.state.idTenant, this.$store.state.globalSearch, this.$store.state.ignoreDiacritics, this.tableParams.perPage, this.tableParams.currentPage, this.tableParams.sortBy, this.tableParams.sortDesc, JSON.stringify(this.tableParams.filters));
		//this.filterItemsRest();
		return this.globalSearchService.getAllByFilter(filter);
	}

	////zatím nepotrebujeme
	fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {		
		return this.fetchDataFromServer();
	}

	refreshItems(items: any[], refreshData: any[]) {	
		return items;
	}

	itemsAll: any[] = [];
	prepareItems(items: any[]) {
		// zde zatim nepotrebujeme
		this.itemsAll = items;
		return items;
	}

	//loadFilters(value: any) { super.loadFilters(value); }
	//createNewClick(elementId: any) { super.createNewClick(elementId); }
	//detailClick(elementId: any) {
	//	super.detailClick(elementId);
	//}
	
	setFields() {
		this.fields = [
			/*	{ key: 'id', label: 'id', sortable: true, class: 'text-center ', optional: true, visible: false },*/
			{ key: 'typeObjectName', label: this.$t('globalSearch.fieldType'), trans: 'globalSearch.fieldType', sortable: true, class: 'text-left ', optional: false, visible: true },
			{ key: 'name', label: this.$t('globalSearch.fieldName'), trans: 'globalSearch.fieldName', sortable: true, class: 'text-left  ', design: 'detail', showAnyTime:true },
			{ key: 'description', label: this.$t('globalSearch.fieldDescription'), trans: 'globalSearch.fieldDescription', sortable: true, class: 'text-left ', optional: false, visible: true },		
			{ key: 'actions', label: this.$t('globalSearch.fieldActions'), trans: 'globalSearch.fieldActions', class: 'text-right' }
		
		]
	};

	////filtry
	setfilters(value: any) {
		if (value != null && value[0].lang == this.filters[0].lang) {
			this.filters = value;
		}
		else {
			this.filters = [
				{ key: 'search', label: this.$t('globalSearch.filterSearch'), trans: 'globalSearch.filterSearch', selected: true, value: null, type: 'text', showAnyTime: true,  lang: this.$store.state.currentLanguage },
				{ key: 'name', label: this.$t('globalSearch.filterName'), trans: 'globalSearch.filterName', selected: false, value: null, type: 'text' },
				{ key: 'description', label: this.$t('globalSearch.filterDescription'), trans: 'globalSearch.filterDescription', selected: false, value: null, type: 'text' }
			];
		
			var taskStateEnums = {
				key: "content", value: 'Vco1ntent', label: this.$t('globalSearch.filterTypeContent'), selected: true, //defaultSelected: true,
				type: 'text', group: true, groupId: 1, groupName: this.$t('globalSearch.filterType'), headName: this.$t('globalSearch.filterType'), isNegative: true };
			var taskStateEnums2 = {
				key: "receiver", value: 'Vre1ceiver', label: this.$t('globalSearch.filterTypeReceiver'), selected: true, //defaultSelected: true,
				type: 'text', group: true, groupId: 1, groupName: this.$t('globalSearch.filterType'), headName: this.$t('globalSearch.filterType'), isNegative: true };
			var taskStateEnums3 = {
				key: "tag", value: 'Vta1g', label: this.$t('globalSearch.filterTypeTag'), selected: true, //defaultSelected: true,
				type: 'text', group: true, groupId: 1, groupName: this.$t('globalSearch.filterType'), headName: this.$t('globalSearch.filterType'), isNegative: true };
			var taskStateEnums4 = {
				key: "task", value: 'Vta1sk', label: this.$t('globalSearch.filterTypeTask'), selected: true, //defaultSelected: true,
				type: 'text', group: true, groupId: 1, groupName: this.$t('globalSearch.filterType'), headName: this.$t('globalSearch.filterType'), isNegative: true };
		
			this.filters.push(taskStateEnums);
			this.filters.push(taskStateEnums2);
			this.filters.push(taskStateEnums3);
			this.filters.push(taskStateEnums4);
		}
	}

	selectItemObjectBase(item: iGlobalItemSearch) {
		if (item.typeObject == "Task") {
			this.$router.push({ name: 'TaskDetail', query: { id: item.id.toString() } });
		}
		else if (item.typeObject == "Receiver") {
			this.$router.push({ name: 'ReceiverDetail', query: { id: item.id.toString() } });
		}
		else if (item.typeObject == "Content") {
			this.$router.push({ name: 'ContentDetail', query: { id: item.id.toString() } });
		}
		else if (item.typeObject == "Tag") {
			this.$router.push({ name: 'TagDetail', query: { id: item.id.toString() } });
		}
	}

	@Watch('$store.state.currentLanguage')
	changeFieldsAfterChangeLanguageD(value: boolean, oldValue: boolean) {
		this.setfilters(null);
	}

};
